import Associations from '../../core/Associations';
import AdvancedSearchContainer from './AdvancedSearchContainer';
import ProjectProvider from '../../core/providers/ProjectProvider';
import PropTypes from 'prop-types';
import { Component } from 'react';

class AdvancedSearch extends Component {

  render() {

    const { project, data, graph, entitlements, components, editMode, resourceIn, rowDisplay, baseLink, projectType,
      viewOptions, label, labelIRI, searchClass, componentType, editRequirements, optimiseForLargeData } = this.props;

    return (
      <ProjectProvider value={this.props.data}>
        <Associations
          key={editMode}
          graph={graph}
          onLoad={this.onLoadAssociations}
          ontologyProjectAssociation={data.ontologyProjectAssociation}
          optimiseForLargeData={optimiseForLargeData}
          component={AdvancedSearchContainer}
          componentType={componentType}
          entitlements={entitlements}
          data={data}
          label={label}
          labelIRI={labelIRI}
          baseLink={baseLink}
          searchClass={searchClass}
          rowDisplay={rowDisplay}
          resourceIn={resourceIn}
          viewOptions={viewOptions}
          editMode={editMode}
          editRequirements={editRequirements}
          project={project}
          projectType={projectType}
          projectLang={data.projectLang}
          components={components}
          skosXL={data.skosXL || false}
          defaultLang={data.defaultLang} />
      </ProjectProvider>
    );
  }
}

AdvancedSearch.propTypes = {
  entitlements: PropTypes.array.isRequired,
  data: PropTypes.object.isRequired,
  baseLink: PropTypes.string.isRequired,
  viewOptions: PropTypes.array,
  rowDisplay: PropTypes.object.isRequired,
  labelIRI: PropTypes.string.isRequired,
  optimiseForLargeData: PropTypes.bool,
  resourceIn: PropTypes.string.isRequired,
  searchClass: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  editRequirements: PropTypes.string,
  graph: PropTypes.string.isRequired,
  components: PropTypes.array,
  componentType: PropTypes.string,
  project: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired
};

export default AdvancedSearch;
